import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Avatar,
} from '@mui/material';
import { Phone } from 'lucide-react';

interface ThankYouDialogProps {
  open: boolean;
  onClose: () => void;
  onTryAgain: () => void;
  agentName?: string;
  agentAvatar?: string;
}

export const ThankYouDialog: React.FC<ThankYouDialogProps> = ({
  open,
  onClose,
  onTryAgain,
  agentName = 'Rachel',
  agentAvatar = 'https://dopmo1eihgbgm.cloudfront.net/67135d6f890cc59eb99e65f9/ai-headshot.webp',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(4px)',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogContent>
        <Box sx={{ textAlign: 'center', py: 2 }}>
          {/* Avatar */}
          <Avatar
            src={agentAvatar}
            alt={agentName}
            sx={{
              width: 100,
              height: 100,
              mx: 'auto',
              mb: 3,
              border: '3px solid #E0E0E0',
            }}
          />

          {/* Thank you message */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: '#333',
              mb: 2,
            }}
          >
            Thank You!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#666',
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Thank you for trying our Enhanced Annual Check-In demo.
            We hope this demonstrates how our AI assistant can help with consistent,
            compliant customer interactions.
          </Typography>

          {/* Actions */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Phone size={20} />}
              onClick={onTryAgain}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
              }}
            >
              Try Another Call
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
              }}
            >
              Close
            </Button>
          </Box>

          {/* Additional info */}
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: '#999',
              mt: 3,
            }}
          >
            This was a demonstration of Prudential's Enhanced Annual Check-In script
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};